import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux'
import './Navigator.scss'

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeTempUserId } from '../../Routers/UserPage';
import SelectLanguage from '../../Footer/SelectLanguage'
import i18n from '../../i18n';

import SignUpSelection from '../../Navigator/SignUpSelection'

import SignUpDialog from '../../Navigator/SignUpDialog'
import LoginDialog from '../../Navigator/LoginDialog'

import { Logout, SetIsShowLoginDialog, SetIsShowSignUpDialog } from '../../Interface'

import { OpenPopUp } from '../../LoginPopupHandler'

import { SetTrackingData } from '../../utils/TrackingData'

class Navigator extends Component {
  state = {
    anchorEl: null,
    show: false,

    isFixed: false,
    isMakeVideo: false,

    isShowSignUpSelector: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleBodyScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleBodyScroll)
  }

  componentWillReceiveProps(nextProps) {
    const { currentPath } = nextProps
    if (currentPath === '/makevideo') this.setState({ isFixed: false, isMakeVideo: true })
    else this.setState({ isMakeVideo: false })
  }

  handleBodyScroll = e => {
    const { currentPath } = this.props

    if (currentPath === '/makevideo') this.setState({ isFixed: false, isMakeVideo: true })
    else this.setState({ isFixed: 80 <= window.scrollY, isMakeVideo: false })
  }

  handleClick = () => {
    this.setState({
      show: !this.state.show
    });
  };

  closePopover = () => {
    this.setState({
      show: false
    });
  };

  handleSignUpDialogOpen = () => {
    this.setState({
      isShowSignUpSelector: false
    })
    SetIsShowSignUpDialog(true)
  }

  handleClickThirdPartyLogin = (url, isSignup = false) => {
    const { value: lang } = this.props
    if (isSignup) SetTrackingData({ lang })
    else SetTrackingData({ lang, isLogin: true })
    OpenPopUp(url)
  }

  loginAfter() {
    const { currentUser, myProfileURL } = this.props
    const tempUserId = makeTempUserId(currentUser);
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* <div className="language_selection_area">
            <SelectLanguage changeLanguage={this.props.changeLanguage}/>
        </div> */}
        <div style={{ position: 'relative' }}>
        <ClickAwayListener onClickAway={this.closePopover}>
          <>
            <div
              className="login_after"
              onClick={this.handleClick}
            >
              <div className="user_name">
                <p lang={this.props.value}>{i18n.t("navigator.login.before.myvideo")}</p>
              </div>
              <div className="user_profile">
                <div className="speech-bubble" style={this.props.completeAlarm ? { display: "block" } : { display: "none" }}>
                  <p className="speech-bubble-number">{this.props.bubbleInnerNumber}</p>
                </div>
                <div className="user_profile_wrap">
                  {myProfileURL && <img src={myProfileURL === 'baseImg' ? "https://front.videomonster.com/images-u6yd72dy/web/profile.png" : myProfileURL} alt="프로필사진" />}
                </div>
              </div>
              <div className="user_more_btn_area">
                <img src="https://front.videomonster.com/images-u6yd72dy/web/more_green_btn.png" alt="사용자 더보기" />
              </div>
            </div>

            <div className={`login-hover-wrap ${this.state.show ? 'show' : 'hide'}`} >
              <div className={`arrow-up ${this.state.show ? 'show' : 'hide'}`} />
              <div className={`login-top`}>
                <div className={`login-top-area ${this.props.maintain ? "hide" : "show"}`}>
                  <div className="user-profile">
                    <div className="user-profile-img-area">
                      {myProfileURL && <img src={myProfileURL === 'baseImg' ? "https://front.videomonster.com/images-u6yd72dy/web/profile.png" : myProfileURL} alt="비몬이" />}
                    </div>
                  </div>
                  <div className="login-user-info">
                    <div style={{ fontWeight: '500', fontSize: '20px' }}>
                      {currentUser.userId ? currentUser.userId : ''}
                    </div>
                    <div>
                      {currentUser.email
                        ? currentUser.email
                        : ''}
                    </div>
                  </div>
                </div>
              </div>
              <div className={`login-middle ${this.props.maintain ? "hide" : "show"}`}>
                <NavLink lang={this.props.value} to={`/user/${tempUserId}/my-video`} onClick={this.closePopover}>
                  <div className={`login-menu login-menu1 ${this.props.value}`}>
                    <div className="alarm-bubble" style={this.props.completeAlarm ? { display: "block" } : { display: "none" }}>
                    </div>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/myIcon.svg" alt="" />
                    <div lang={this.props.value}>{i18n.t("myvideo.title")}</div>
                  </div>
                </NavLink>
                <NavLink
                  lang={this.props.value}
                  to={`/user/${tempUserId}/liked-video`}
                  target="_blank"
                  onClick={this.closePopover}
                >
                  <div
                    className={`login-menu login-menu2 ${this.props.value}`}
                    style={{
                      borderLeft: '1px solid #eeeeee',
                      borderRight: '1px solid #eeeeee'
                    }}
                  >
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/likeIcon.svg" alt="" />

                    <div lang={this.props.value}>{i18n.t("navigator.login.before.likedvideo")}</div>
                  </div>
                </NavLink>
                <NavLink
                  lang={this.props.value}
                  to={`/user/${tempUserId}/account-setting`}
                  onClick={this.closePopover}
                >
                  <div className={`login-menu login-menu3 ${this.props.value}`}>
                    <img src="https://front.videomonster.com/images-u6yd72dy/web/accountIcon.svg" alt="" />

                    <div>{i18n.t("navigator.login.before.idsetting")}</div>
                  </div>
                </NavLink>
              </div>
              <div lang={this.props.value} className="login-logout" onClick={()=>Logout()}>
                {i18n.t("global.logout")}
              </div>
            </div>
          </>
        </ClickAwayListener>
        </div>
      </div>
    );
  }
  loginBefore() {
    return (
        <div className="header_btn_area">
            <div className="login_btn" onClick={() => SetIsShowLoginDialog(true)}>
                <p lang={this.props.value}>{i18n.t("global.login")}</p>
            </div>
            |
            <div className="signup_btn" onClick={e => {
                this.setState({ isShowSignUpSelector: !this.state.isShowSignUpSelector })
            }}>
              <p lang={this.props.value}>{i18n.t("global.signup")}</p>
            </div>
            {/* <div className="language_selection_area">
                <SelectLanguage changeLanguage={this.props.changeLanguage}/>
            </div> */}
        </div>
    );
  }

  render() {
    const { isShowLoginPopup, isShowSignUpPopup, currentPath } = this.props
    const { isFixed, isMakeVideo, isShowSignUpSelector } = this.state
    return (
      <>
        {
          isFixed &&
          <div style={{ height: 80 }} />
        }
        <div className={`wadiz-new_navigatorAreaWrapper prohibit-drag ${isFixed ? 'top-fixed' : ''} ${isMakeVideo ? 'make-video' : ''}`}>
          <div className="layout">
            <div className="logo_area">
              <NavLink to="/home" className="item">
                <img src="https://front.videomonster.com/images-u6yd72dy/web/logo.png" alt="Video monster 로고" />
              </NavLink>
            </div>

            <div className="header">
              <NavLink to="/designselect" className={`item ${currentPath === '/designselect' ? 'selected' : ''}`}>
                <p>{i18n.t("navigator.menu.designselect")}</p>
              </NavLink>
              <NavLink to="/wadizgallery" className={`item ${currentPath === '/wadizgallery' ? 'selected' : ''}`}>
                <p>와디즈 갤러리</p>
              </NavLink>
              <NavLink to="/useguide" className={`item ${currentPath === '/useguide' ? 'selected' : ''}`}>
                <p>{i18n.t("navigator.menu.guide.faq")}</p>
              </NavLink>
            </div>

            {this.props.currentUser
              ? this.loginAfter()
              : this.loginBefore()}

            {
              isShowSignUpSelector &&
              <ClickAwayListener onClickAway={e => {
                e.preventDefault()
                this.setState({ isShowSignUpSelector: false })
              }}>
                <SignUpSelection
                  handleSignUpDialogOpen={this.handleSignUpDialogOpen}
                  handleClickThirdPartyLogin={url => {
                      this.setState({ isShowSignUpSelector: false })
                      this.handleClickThirdPartyLogin(url)
                  }}
                />
              </ClickAwayListener>
            }
          </div>
        </div>

        <SignUpDialog
          open={isShowSignUpPopup}
          onClose={() => SetIsShowSignUpDialog(false)}
        />
        <LoginDialog
          open={isShowLoginPopup}
          onClose={() => SetIsShowLoginDialog(false)}
          handleClickThirdPartyLogin={this.handleClickThirdPartyLogin}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
  value: state.langStore.lang,
  myProfileURL: state.myProfileURLStore.myProfileURL,

  isShowLoginPopup: state.loginPopupShowStore.isShowLoginPopup,
  isShowSignUpPopup: state.signUpPopupShowStore.isShowSignUpPopup,

  currentPath: state.currentPathStore.currentPath
})

export default connect(
  mapStateToProps,
  null
)(Navigator)